/* eslint-disable import/prefer-default-export */
const MAX_CHAR = 2000;

export { MAX_CHAR };
